import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { useParams } from 'react-router-dom';

import { useBills } from '@/Billing/useBills';
import { useStructures } from '@/Structures/useStructures';

import FeesTable from './table';

const useStyles = makeStyles({
  wrapper: { display: 'flex', width: '100%' },
  container: { display: 'flex', flexDirection: 'column', width: '100%' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', padding: 0 },
});

interface IProps {
  stripeConnect: boolean;
}

export const FeesView: React.FC<IProps> = ({ stripeConnect: _stripeConnect }) => {
  const classes = useStyles();

  // ✅ grab the `:structureId` param (matches your "/properties/:structureId" route)
  const { structureId } = useParams<{ structureId: string }>();
  if (!structureId) {
    throw new Error('MISSING_REQUIRED_ROUTE_DATA');
  }

  // 1) bills
  const { bills = [], isLoading: billsLoading } = useBills(structureId);

  // 2) structures (which come back with a `.units` array on each one)
  const { structures = [], isLoading: structsLoading } = useStructures();
  const structure = structures.find((s) => s.id === structureId);
  const units = structure?.units ?? [];

  // 3) only show once both are done
  const isLoading = billsLoading || structsLoading;

  // 4) grab your fees
  const filteredLineItems = bills.flatMap((b) =>
    b.lineItems.filter((li) => ['SPLIT', 'FLAT', 'UNIT_FLAT'].includes(li.type)),
  );

  return (
    <div className={classes.wrapper} data-component-id="STRUCTURE-VIEW">
      {!isLoading && <FeesTable fees={filteredLineItems} units={units} />}
    </div>
  );
};
